jQuery(".carousel").swipe({
    swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
        // Treat left swipe as next
        if (direction == 'left') {
            jQuery(this).carousel('next');
        }

        // Treat right swipe as previous
        if (direction == 'right') {
            jQuery(this).carousel('prev');
        }
    },
    allowPageScroll: "vertical"
});
